const DEFAULT_ICON = '/logo192.png';

export const isBrowserNotificationSupported = () =>
  typeof window !== 'undefined' && typeof Notification !== 'undefined';

export const getBrowserNotificationPermission = () => {
  if (!isBrowserNotificationSupported()) return 'unsupported';
  return Notification.permission;
};

export const registerNotificationServiceWorker = async () => {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return null;

  try {
    return await navigator.serviceWorker.register('/service-worker.js');
  } catch (_error) {
    return null;
  }
};

export const requestBrowserNotificationPermission = async () => {
  if (!isBrowserNotificationSupported()) return 'unsupported';

  await registerNotificationServiceWorker();
  return Notification.requestPermission();
};

export const showBrowserNotification = async ({ title, body, tag, url = '/app' }) => {
  if (getBrowserNotificationPermission() !== 'granted') return false;

  const options = {
    body,
    icon: DEFAULT_ICON,
    badge: DEFAULT_ICON,
    tag,
    renotify: true,
    data: { url },
  };

  try {
    if (typeof navigator !== 'undefined' && navigator.serviceWorker?.getRegistration) {
      const registration = await navigator.serviceWorker.getRegistration();
      if (registration) {
        await registration.showNotification(title, options);
        return true;
      }
    }

    // This fallback covers browsers that support notifications without service workers.
    // eslint-disable-next-line no-new
    new Notification(title, options);
    return true;
  } catch (_error) {
    return false;
  }
};
